"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = exports.isNotNullable = exports.asyncEmpty = exports.empty = exports.toIterator = exports.isIterator = exports.isAsyncIterable = exports.isIterable = void 0;
var tslib_1 = require("tslib");
function isIterable(a) {
    return typeof (a === null || a === void 0 ? void 0 : a[Symbol.iterator]) === "function";
}
exports.isIterable = isIterable;
function isAsyncIterable(a) {
    return typeof (a === null || a === void 0 ? void 0 : a[Symbol.asyncIterator]) === "function";
}
exports.isAsyncIterable = isAsyncIterable;
function isIterator(a) {
    return typeof (a === null || a === void 0 ? void 0 : a.next) === "function";
}
exports.isIterator = isIterator;
function toIterator(iterable) {
    if (isIterable(iterable)) {
        return iterable[Symbol.iterator]();
    }
    if (isAsyncIterable(iterable)) {
        return iterable[Symbol.asyncIterator]();
    }
    throw new TypeError("toIterator: iterable must be type of Iterable or AsyncIterable");
}
exports.toIterator = toIterator;
// eslint-disable-next-line @typescript-eslint/no-empty-function
var empty = function () { return tslib_1.__generator(this, function (_a) {
    return [2 /*return*/];
}); };
exports.empty = empty;
// eslint-disable-next-line @typescript-eslint/no-empty-function
var asyncEmpty = function () { return tslib_1.__asyncGenerator(this, arguments, function () { return tslib_1.__generator(this, function (_a) {
    return [2 /*return*/];
}); }); };
exports.asyncEmpty = asyncEmpty;
var isNotNullable = function (a) {
    return a !== null && a !== undefined;
};
exports.isNotNullable = isNotNullable;
var isPromise = function (a) {
    if (a instanceof Promise) {
        return true;
    }
    if (a !== null &&
        typeof a === "object" &&
        typeof a.then === "function" &&
        typeof a.catch === "function") {
        return true;
    }
    return false;
};
exports.isPromise = isPromise;
//# sourceMappingURL=utils.js.map